// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
  }
  
  .associated-members {
    width: 100%;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .associated-members h2 {
    font-size: 24px; /* Larger font size for header */
    margin-bottom: 20px;
    text-align: center; /* Center-align header */
  }
  
  .associated-members-sections {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 40px;
  }
  
  .associated-members-section {
    flex: 0 1 auto;
    min-width: 400px;
    max-width: 650px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .data-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    font-size: 14px;
  }
  
  .bar-container {
    flex-grow: 1;
    margin: 0 10px;
  }
  
  .bar {
    height: 8px;
    background-color: #4caf50;
    border-radius: 3px;
  }
  
  .data-row p {
    margin: 0;
  }
  
  .search-people {
    display: flex;
    margin-bottom: 20px;
    width: 0%; /* Ensures the search bar takes full width */
    justify-content: center; /* Centers the search bar */
  }
  
  .search-people input {
    width: 20px; /* Reduced width for the search bar */
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px 0 0 5px;
    outline: none;
    font-size: 16px;
  }
  
  .search-people .search-btn {
    background-color: #007bff;
    border: none;
    color: white;
    padding: 8px 12px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 0 5px 5px 0;
  }
  
  .search-people .search-btn:hover {
    background-color: #0056b3;
  }
  
  .peoples-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
  }
  
  .peoples-card {
    width: 220px;
    padding: 15px;
    text-align: center;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
  }
  
  .peoples-card:hover {
    transform: scale(1.05);
  }
  
  .peoples-card img {
    width: 100%;
    height: 100px;
    object-fit: cover;
    border-radius: 50%;
  }
  
  .peoples-card h3 {
    margin: 10px 0 5px;
  }
  
  .peoples-card p {
    margin: 0;
    color: #555;
  }
  
  .peoples-card button {
    background-color: #0073b1;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    font-size: 14px;
  }
  
  .show-more-btn {
    display: block;
    margin: 20px auto;
    padding: 8px 16px;
    background-color: #0073b1;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .page-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  
  .add-btn {
    background-color: #270388;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 14px;
    cursor: pointer;
    margin-left: 10px;
  }
  
  .add-btn:hover {
    background-color: #270388;
  }
  
  .back-btn {
    position: fixed; /* Fix the button in place */
    left: 100px; /* Position 20px from the left edge of the screen */
    top: 460px;  /* Optional: Add space from the top */
    background: none;
    border: none;
    font-size: 16px;
    color: #007bff;
    cursor: pointer;
    z-index: 1000; /* Ensure it's above other elements */
  }
  
  .back-btn:hover {
    color: #f5f6f8;
    text-decoration: underline;
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .associated-members-sections {
      gap: 20px;
    }
  
    .associated-members-section {
      min-width: auto;
      width: 45%;
    }
  
    .peoples-card {
      width: 30%; /* Display three cards in a row */
    }
  }

  /* For smaller screens (phones) */
@media (max-width: 767px) {
  .container {
    padding: 10px;
  }

  .associated-members h2 {
    font-size: 20px;
  }
  .associated-members-sections {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .associated-members-section {
    min-width: auto;
    width: 90%;
    max-width: none;
    padding: 15px;
  }

  .search-people input {
    width: 70%;
    font-size: 14px;
  }

  .search-people .search-btn {
    font-size: 14px;
  }

  .peoples-list {
    gap: 15px;
  }
  .peoples-card {
    width: 45%; /* Display two cards in a row */
  }

  .back-btn {
    left: 20px;
    top: auto;
    bottom: 20px;
  }
}

/* For even smaller screens (older iPhones) */
@media (max-width: 320px) {
  .peoples-card {
    width: 90%; /* Display one card in a row */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/People.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,gCAAgC;IACjD,mBAAmB;IACnB,kBAAkB,EAAE,wBAAwB;EAC9C;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,4CAA4C;IACvD,uBAAuB,EAAE,2BAA2B;EACtD;;EAEA;IACE,WAAW,EAAE,qCAAqC;IAClD,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe,EAAE,4BAA4B;IAC7C,WAAW,EAAE,mDAAmD;IAChE,UAAU,GAAG,qCAAqC;IAClD,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa,EAAE,qCAAqC;EACtD;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;EACA;IACE;MACE,SAAS;IACX;;IAEA;MACE,eAAe;MACf,UAAU;IACZ;;IAEA;MACE,UAAU,EAAE,iCAAiC;IAC/C;EACF;;EAEA,iCAAiC;AACnC;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,UAAU;IACV,eAAe;IACf,aAAa;EACf;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;EACA;IACE,UAAU,EAAE,+BAA+B;EAC7C;;EAEA;IACE,UAAU;IACV,SAAS;IACT,YAAY;EACd;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,UAAU,EAAE,8BAA8B;EAC5C;AACF","sourcesContent":[".container {\n    width: 100%;\n    max-width: 1300px;\n    margin: 0 auto;\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n  }\n  \n  .associated-members {\n    width: 100%;\n    margin: 20px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .associated-members h2 {\n    font-size: 24px; /* Larger font size for header */\n    margin-bottom: 20px;\n    text-align: center; /* Center-align header */\n  }\n  \n  .associated-members-sections {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 40px;\n  }\n  \n  .associated-members-section {\n    flex: 0 1 auto;\n    min-width: 400px;\n    max-width: 650px;\n    padding: 20px;\n    background-color: #f5f5f5;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .data-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px 0;\n    font-size: 14px;\n  }\n  \n  .bar-container {\n    flex-grow: 1;\n    margin: 0 10px;\n  }\n  \n  .bar {\n    height: 8px;\n    background-color: #4caf50;\n    border-radius: 3px;\n  }\n  \n  .data-row p {\n    margin: 0;\n  }\n  \n  .search-people {\n    display: flex;\n    margin-bottom: 20px;\n    width: 0%; /* Ensures the search bar takes full width */\n    justify-content: center; /* Centers the search bar */\n  }\n  \n  .search-people input {\n    width: 20px; /* Reduced width for the search bar */\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px 0 0 5px;\n    outline: none;\n    font-size: 16px;\n  }\n  \n  .search-people .search-btn {\n    background-color: #007bff;\n    border: none;\n    color: white;\n    padding: 8px 12px;\n    font-size: 16px;\n    cursor: pointer;\n    border-radius: 0 5px 5px 0;\n  }\n  \n  .search-people .search-btn:hover {\n    background-color: #0056b3;\n  }\n  \n  .peoples-list {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 20px;\n  }\n  \n  .peoples-card {\n    width: 220px;\n    padding: 15px;\n    text-align: center;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s ease;\n  }\n  \n  .peoples-card:hover {\n    transform: scale(1.05);\n  }\n  \n  .peoples-card img {\n    width: 100%;\n    height: 100px;\n    object-fit: cover;\n    border-radius: 50%;\n  }\n  \n  .peoples-card h3 {\n    margin: 10px 0 5px;\n  }\n  \n  .peoples-card p {\n    margin: 0;\n    color: #555;\n  }\n  \n  .peoples-card button {\n    background-color: #0073b1;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 10px;\n    font-size: 14px;\n  }\n  \n  .show-more-btn {\n    display: block;\n    margin: 20px auto;\n    padding: 8px 16px;\n    background-color: #0073b1;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n  }\n  \n  .page-content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n  }\n  \n  .add-btn {\n    background-color: #270388;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 5px 10px;\n    font-size: 14px;\n    cursor: pointer;\n    margin-left: 10px;\n  }\n  \n  .add-btn:hover {\n    background-color: #270388;\n  }\n  \n  .back-btn {\n    position: fixed; /* Fix the button in place */\n    left: 100px; /* Position 20px from the left edge of the screen */\n    top: 460px;  /* Optional: Add space from the top */\n    background: none;\n    border: none;\n    font-size: 16px;\n    color: #007bff;\n    cursor: pointer;\n    z-index: 1000; /* Ensure it's above other elements */\n  }\n  \n  .back-btn:hover {\n    color: #f5f6f8;\n    text-decoration: underline;\n  }\n  @media (min-width: 768px) and (max-width: 991px) {\n    .associated-members-sections {\n      gap: 20px;\n    }\n  \n    .associated-members-section {\n      min-width: auto;\n      width: 45%;\n    }\n  \n    .peoples-card {\n      width: 30%; /* Display three cards in a row */\n    }\n  }\n\n  /* For smaller screens (phones) */\n@media (max-width: 767px) {\n  .container {\n    padding: 10px;\n  }\n\n  .associated-members h2 {\n    font-size: 20px;\n  }\n  .associated-members-sections {\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n  }\n\n  .associated-members-section {\n    min-width: auto;\n    width: 90%;\n    max-width: none;\n    padding: 15px;\n  }\n\n  .search-people input {\n    width: 70%;\n    font-size: 14px;\n  }\n\n  .search-people .search-btn {\n    font-size: 14px;\n  }\n\n  .peoples-list {\n    gap: 15px;\n  }\n  .peoples-card {\n    width: 45%; /* Display two cards in a row */\n  }\n\n  .back-btn {\n    left: 20px;\n    top: auto;\n    bottom: 20px;\n  }\n}\n\n/* For even smaller screens (older iPhones) */\n@media (max-width: 320px) {\n  .peoples-card {\n    width: 90%; /* Display one card in a row */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
